import { useMemo } from 'react';
import BikingMtn from '@alltrails/denali/icons/BikingMtn';
import BikingRoad from '@alltrails/denali/icons/BikingRoad';
import Hiking from '@alltrails/denali/icons/Hiking';
import { StyleId } from '../../types/Styles';

export const useExtraMenuItemIcon = (styleId: StyleId) => {
  const icon = useMemo(() => {
    switch (styleId) {
      case 'waymarkedCycling':
        return <BikingRoad />;
      case 'waymarkedHiking':
        return <Hiking />;
      case 'waymarkedMTB':
        return <BikingMtn />;
      default:
        return null;
    }
  }, [styleId]);

  return icon;
};
